module.exports = __webpack_public_path__ + "img/zz2.822c0351.png";